import { AttributeDefinition } from '../attributes/attributeDefinition';
import { QuestionDefinitionModel } from '../form/question-definition-model';

export class SurveyQuestion extends QuestionDefinitionModel {
  public static parse(data: any): SurveyQuestion {
    if (!data) return null;

    let surveyQuestion = new SurveyQuestion();
    Object.assign(surveyQuestion, data);

    surveyQuestion.attributeDefinition = AttributeDefinition.parse(
      surveyQuestion.attributeDefinition
    );
    return surveyQuestion;
  }
}
